
'use client';

import { useFirebaseClient } from '../client-provider';

export function useUser() {
  // Always use the real Firebase Authentication state from the provider.
  // The mock user was causing a mismatch between the app's query `ownerId`
  // and the security rule's `request.auth.uid`.
  const { user, loading } = useFirebaseClient();
  return { user, loading };
}
